module.exports = __webpack_public_path__ + "img/guest.de43c312.png";